var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28961 4.16974C2.28863 3.13352 3.12838 2.29297 4.16461 2.29297H15.8372C16.8729 2.29297 17.7125 3.1327 17.7122 4.1684L17.7096 15.8351C17.7094 16.8704 16.87 17.7097 15.8346 17.7097H4.1756C3.14076 17.7097 2.30158 16.8713 2.3006 15.8364L2.28961 4.16974Z",
    stroke: "#404553",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29524 8.13185C2.29208 7.20915 3.03919 6.45947 3.9619 6.45947H16.0444C16.9654 6.45947 17.7118 7.2065 17.711 8.12751C17.7103 9.04745 16.9643 9.79281 16.0444 9.79281H3.9619C3.04365 9.79281 2.29839 9.05009 2.29524 8.13185Z",
    fill: "#00B4D7",
    stroke: "#404553",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_65",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 13,
    width: 6,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00365 13.9673C4.99927 13.6191 5.28035 13.3345 5.6286 13.3345H10.2111C10.557 13.3345 10.8371 13.6154 10.8361 13.9614C10.835 14.3058 10.5555 14.5845 10.2111 14.5845H5.6286C5.28648 14.5845 5.00795 14.3094 5.00365 13.9673Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6286 14.5845H10.2111V12.0845H5.6286V14.5845ZM10.2111 13.3345H5.6286V15.8345H10.2111V13.3345ZM5.6286 13.3345C5.97072 13.3345 6.24925 13.6095 6.25355 13.9516L3.75375 13.983C3.76664 15.0093 4.60225 15.8345 5.6286 15.8345V13.3345ZM9.58604 13.9576C9.58708 13.6131 9.8666 13.3345 10.2111 13.3345V15.8345C11.2444 15.8345 12.0829 14.9985 12.0861 13.9651L9.58604 13.9576ZM10.2111 14.5845C9.86512 14.5845 9.585 14.3035 9.58604 13.9576L12.0861 13.9651C12.0892 12.9274 11.2488 12.0845 10.2111 12.0845V14.5845ZM5.6286 12.0845C4.58385 12.0845 3.74062 12.9384 3.75375 13.983L6.25355 13.9516C6.25793 14.2998 5.97685 14.5845 5.6286 14.5845V12.0845Z",
    fill: "#404553"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.ed3bb2cbebab003e79c437bad3798f47.svg";
export { ForwardRef as ReactComponent };